export const requestTypes = ['get', 'find', 'update', 'create', 'remove', 'patch'];
